// The header's Close button (Figma 1095:58193) and, once the helpdesk ticket is Closed, its static
// Closed pill (Figma 1095:58179). The pill is a label, not a control: no hover, nothing to click.

import { CloseTicketIcon } from './icons';

const PILL = 'flex h-8 items-center gap-2 rounded-full border py-1 pr-3 pl-2 text-[13px] leading-[18px] font-normal';

export function CloseTicketControl({
  helpdeskOpen,
  canClose,
  closing,
  onClose,
}: {
  helpdeskOpen: boolean | null;
  canClose: boolean;
  closing: boolean;
  onClose: () => void;
}) {
  if (helpdeskOpen === false) {
    return (
      <span className={`${PILL} border-gray-500 bg-background text-text-heading`}>
        <CloseTicketIcon className="shrink-0" />
        Closed
      </span>
    );
  }
  if (!canClose) return null;
  return (
    <button
      type="button"
      onClick={onClose}
      disabled={closing}
      className={`${PILL} border-surface-action bg-surface-action text-white disabled:opacity-60`}
    >
      <CloseTicketIcon className="shrink-0" />
      {closing ? 'Closing…' : 'Close'}
    </button>
  );
}
